// extracted by mini-css-extract-plugin
module.exports = {"ball-pulse-sync":"styles_ball-pulse-sync__C0SwJ","section-loader":"styles_section-loader__1pVwm"};